import { CalendarSync } from 'src/api/requests';

export const onSetCalendar = async value => {
  const values = {
    calendar: value,
  };
  return CalendarSync.setCalendar(values);
};
